import { Button } from "@/components/ui/button";
import { Trophy, Edit3, Save, X, RefreshCw, Sparkles } from "lucide-react";

const OUTLINE = "border-gray-700 text-gray-300 hover:bg-white/10";
const TEAL = "bg-ism-teal/20 text-ism-teal border border-ism-teal/30 hover:bg-ism-teal/30";
const Spinner = () => <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-white mr-2" />;

const PERIODS = ["month", "quarter", "year"];

export const GoalsHeader = ({ hasHierarchy, isEditing, saving, recalculating, onCreate, onRecalculate, onEdit, onCancel, onSave }) => (
  <div className="flex items-start justify-between gap-4 flex-wrap">
    <div>
      <h1 className="text-2xl font-normal text-white mb-2 flex items-center gap-2">
        <Trophy className="h-8 w-8 text-ism-teal" />
        <span className="text-ism-teal">Goals & Progress</span>
      </h1>
      <p className="text-gray-400">Track your performance and milestones</p>
    </div>

    <div className="flex gap-2 flex-wrap">
      {!hasHierarchy && (
        <Button onClick={onCreate} className={TEAL} data-testid="create-hierarchy-btn">
          <Sparkles className="h-4 w-4 mr-2" /> Create Goal Hierarchy
        </Button>
      )}
      {hasHierarchy && (
        <Button onClick={onRecalculate} disabled={recalculating} variant="outline" className={OUTLINE} data-testid="recalculate-goals-btn">
          <RefreshCw className={`h-4 w-4 mr-2 ${recalculating ? "animate-spin" : ""}`} /> Recalculate
        </Button>
      )}
      {!isEditing ? (
        <Button onClick={onEdit} variant="outline" className={OUTLINE} data-testid="edit-goals-btn">
          <Edit3 className="h-4 w-4 mr-2" /> Edit Goals
        </Button>
      ) : (
        <>
          <Button onClick={onCancel} variant="outline" className={OUTLINE} data-testid="cancel-edit-goals-btn">
            <X className="h-4 w-4 mr-2" /> Cancel
          </Button>
          <Button onClick={onSave} disabled={saving} className={TEAL} data-testid="save-goals-btn">
            {saving ? <Spinner /> : <Save className="h-4 w-4 mr-2" />} Save Changes
          </Button>
        </>
      )}
    </div>
  </div>
);

export const PeriodSelector = ({ value, onChange }) => (
  <div className="flex gap-2">
    {PERIODS.map((period) => (
      <Button
        key={period}
        onClick={() => onChange(period)}
        variant={value === period ? "default" : "outline"}
        className={value === period ? TEAL : "border-gray-700 text-gray-400 hover:bg-white/5"}
        data-testid={`period-${period}`}
      >
        {period.charAt(0).toUpperCase() + period.slice(1)}
      </Button>
    ))}
  </div>
);
